import {Button} from '../../button/button';
import {ChevronDown} from '../../icon/svg/chevron-down-icon';
import {Stack} from '../../layout/stack/stack';
import {Body, type TextAlign} from '../../typography/body';

type Props = {
    label: string;
    onClick?: () => void;
    getButtonRef?: (ref: HTMLElement) => void;
    isSmall?: boolean;
    textAlign?: TextAlign;
};

export function DropdownButton(props: Props) {
    return (
        <Button
            variant='text-secondary-dark'
            size={props.isSmall ? 'small' : 'big'}
            onClick={props.onClick}
            noPadding={true}
            getButtonRef={props.getButtonRef}
        >
            <Stack isHorizontal={true} spacing={6} alignItems='center'>
                <Body textAlign={props.textAlign}>{props.label}</Body>
                <div className='mb-2'>
                    {/* @ts-expect-error */}
                    <ChevronDown color='black' alignCenter={true} size={12} />
                </div>
            </Stack>
        </Button>
    );
}
